import { z } from 'zod';

export const GcpProjectIdRegex = /^[a-z][a-z0-9-]{4,28}[a-z0-9]$/;

export const GcpProjectIdSchema = z.string().trim().regex(GcpProjectIdRegex, {
  error: 'GCP project ID must be 6–30 lowercase letters, numbers, or hyphens',
});
